<template>


		<div class="search-input-wrapper search-simple">
			<md-field class="input-group search-input-group">

				<md-input type="search"
						  id="search-input"
						  name="query"
						  class="form-control search-input"
						  v-model.lazy="query"
						  aria-label="Search Users..."
						  v-on:keyup.enter="addApiUrls()"></md-input>
				<label for="search-input" class="form-control-placeholder">Search Users...</label>
				<span class="input-group-btn search-clear" v-if="query != '' && query != null">
					<input type="submit" value="" class="icon-close submit-input" v-on:click="clearSearch()" />
				</span>
				<span class="input-group-btn search-submit">
					<input class="icon-search submit-input" type="submit" value="search" v-on:click="addApiUrls()" />
				</span>
			</md-field>


		</div>



</template>

<script>
	export default {
		props: ['searchtext', 'isuserpagercall'],
		data: function () {
			return {
				query: '',
				isUserPagerCall: false
			}
		},
		watch: {
			searchtext(val, oldVal) {
				this.query = val;
			}
		},
		mounted() {
			this.query = this.searchText || '';
		},
		methods: {
			addApiUrls() {
				let queryParams = {
					'query': this.query,
					'isUserPagerCall': this.isUserPagerCall
				};
				this.$emit('setuserfilter', queryParams);
			},
			clearSearch() {
				this.query = '';

				this.addApiUrls();
			}
		}
	}

</script>